import { useEffect, useState } from "react";
import { Box, Button, CircularProgress, Typography } from "@mui/material";
import { useForm } from "react-hook-form";
import { t } from "i18next";
import { useCreateUpdateSubdivisionMutation } from "../../../middleware/usersApi";
import { useLazyGetFacilitySelectElementsWithSearchQuery } from "../../../middleware/facilitiesApi";
import { basicInformationConfig } from "./form-config";
import FormItem from "../../components/FormItem";
import { WarningValidationForm } from "../../components/Notifications";
import { formFields } from "./columns";
import { useAction } from "../../../hooks/actions";
import { formatAddress } from "../../../helpers/helper";

const AddSubdivision = () => {
  const { setIsErrorSubmit, setIsSuccessSubmit } = useAction();
  const [facilities, setFacilities] = useState([]);
  const [createUpdateSubdivision, { isLoading, error, isSuccess }] = useCreateUpdateSubdivisionMutation();
  const [getFacilitySelectElementsWithSearch, { isLoading: isLoadingFacilities }] =
    useLazyGetFacilitySelectElementsWithSearchQuery();

  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm({
    mode: "onChange",
  });

  const isGroup = watch(formFields.isGroup);
  const addresses = watch(formFields.serviceAreas);
  const isWarningValidation = !!Object.keys(errors).length;
  useEffect(() => {
    if (!addresses) return;
    if (!addresses[0]?.address) return;

    setFacilities([]);
    addresses.map(({ address }) => {
      if (!address) return;
      getFacilitySelectElementsWithSearch({
        name: "",
        includeAddress: true,
        subdivision: address.region,
        city: address.city || address.town,
      }).then((response) => {
        if (response.data) {
          setFacilities((prev) => [...prev, ...response.data]);
        }
      });
    });
  }, [JSON.stringify(addresses)]);

  const onSubmit = (data) => {
    const subdivisionIds = data.subdivisionIds || [];
    const preparedData = {
      name: data.name,
      isGroup: data.isGroup,
      subdivisionIds,
      addresses: data.serviceAreas.map(({ address }) => ({ ...address })),
    };
    createUpdateSubdivision(preparedData).then((response) => {
      if (!response.error) {
        reset({});
        setFacilities([]);
      }
    });
  };

  const formConfig = basicInformationConfig(isGroup).filter((item) => item.isVisible);

  useEffect(() => {
    setIsErrorSubmit(error);
  }, [error]);

  useEffect(() => {
    setIsSuccessSubmit(isSuccess);
  }, [isSuccess]);

  return (
    <Box>
      <Box className="template_page-header">
        <Typography className="title-page">Добавить подразделение</Typography>
        <Box className="template_page-header-buttons">
          <Button
            form="add-subdivision-form"
            className="btn btn-primary-fill"
            type="submit"
            disabled={isWarningValidation || isLoading}
          >
            {t("button:save")}
          </Button>
        </Box>
      </Box>

      <Box className="add-subdivision">
        <form className="scrolled-form" id="add-subdivision-form" onSubmit={handleSubmit(onSubmit)}>
          <Box className="basic_form">
            <Box className="add-subdivision__content">
              {formConfig.map(({ id, name, label, rules, CustomFormItem, input, ...rest }) =>
                CustomFormItem ? (
                  <CustomFormItem key={name} control={control} errors={errors} name={name} {...rest} />
                ) : (
                  <FormItem
                    key={id}
                    control={control}
                    errors={errors}
                    name={name}
                    label={label}
                    input={input}
                    {...rest}
                  />
                )
              )}
            </Box>
          </Box>
        </form>

        {!isLoadingFacilities ? (
          facilities.length > 0 && (
            <Box className="add-subdivision__objects">
              <Box className="add-subdivision__objects-title">Объекты попадающие в подразделение</Box>
              <Box className="add-subdivision__objects-container">
                {facilities.map((item, index) => (
                  <Box>
                    {index + 1}. {item.name} {formatAddress(item.address)}
                  </Box>
                ))}
              </Box>
            </Box>
          )
        ) : (
          <CircularProgress />
        )}
      </Box>

      {isWarningValidation && <WarningValidationForm isWarning={isWarningValidation} />}
    </Box>
  );
};

export default AddSubdivision;
